module.exports = "/_next/static/images/dcd444b48e0d78af8ff968500593b8ef-credit-card-prepayment@1x.png";